import React, { FunctionComponent, useCallback, FormEventHandler } from 'react';
import { withBufferedValue } from '../../decorators/withBufferedValue/withBufferedValue';
import { prepareProps } from '../../utils/propUtils';
import { InputLayout, InputLayoutProps } from '../InputLayout/InputLayout';
import sharedStyles from '../sharedStyles.module.css';

export type NumberInputProps = Omit<
  InputLayoutProps,
  'children' | 'onInput' | 'onChange' | 'onInputCapture' | 'onChangeCapture'
> & {
  value: number | null | undefined;
  onInput: (value: number | null) => void;
};

export const NumberInput: FunctionComponent<NumberInputProps> = React.memo(
  (props) => {
    const { value, onInput, ...remainingProps } = prepareProps({
      props,
      ignoreChildren: true
    });

    const handleInput: FormEventHandler<HTMLInputElement> = useCallback(
      (event) => {
        const stringValue = event.currentTarget.value.trim();
        const numberValue = stringValue !== '' ? Number(stringValue) : NaN;
        onInput(isNaN(numberValue) ? null : numberValue);
      },
      [onInput]
    );

    return (
      <InputLayout {...remainingProps}>
        {() => (
          <input
            type="number"
            className={sharedStyles.inputBaseStyle}
            value={value !== null ? value : ''}
            onInput={handleInput}
            data-testid="NumberInput.input"
          ></input>
        )}
      </InputLayout>
    );
  }
);

export const BufferedNumberInput = withBufferedValue(NumberInput);
